/**salesConfigs
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */

import { Logger } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';
import { PinoLogger } from 'nestjs-pino';
import { NestJsLogger } from '../../logger/nest-js-logger';
import { AppModule } from './app/app.module';
import {appSettings} from '../../config';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
import transportConfigs from '../config';


async function bootstrap() {
  const app = await NestFactory.create(AppModule,
    { logger: new NestJsLogger( new PinoLogger({pinoHttp: {level: transportConfigs.loggingMode}}) ) }
  );
  // app.enableCors(); 
  app.enableCors({
    origin: true,
    methods: 'GET,HEAD,PUT,PATCH,POST,DELETE,OPTIONS',
    // credentials: true,
});
  const globalPrefix = 'erpx';
  app.setGlobalPrefix(globalPrefix);
  const port = appSettings.transport_port;
  const options = new DocumentBuilder()
    .setTitle('ERPX')
    .setDescription('ERPX')
    .setVersion('1.0')
    .addTag('')
    .build();
    const document = SwaggerModule.createDocument(app, options);
  SwaggerModule.setup('erpx', app, document);
  // await app.listen(3000);
  await app.listen(port, () => {
    Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix);
  });
}

bootstrap();
